import angular from "angular";
import { CacheService } from "@common/service/cache.service";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { Subject } from "@common/model/subject";
import { Util } from "@common/util";
import * as toastr from "toastr";
import { MODULES, MODULE_ACTIONS, MODULES_DEFAULT } from "@common/model/constants";


export interface ITeamPermissionService {
    isModuleAllowedForTeam(team: Subject, module: any): boolean;
    isDiscussionsAllowed(subject?: Subject): boolean;
    orgPermissions;
    moduleDisabledAlert: Function;
}
export class TeamPermissionService implements ITeamPermissionService {
    orgPermissions;
    static $inject = ["CacheService", "ApiAdapterService"];
    constructor(
        private $_cache: CacheService,
        private $_api: JavaApiAdapterService
    ) {
        this.resetPermissions();
        let tp = this.$_cache.getUserTeamPermissions();
        if (!!tp) {
            this.init(tp);
        }
    }

    init = (teamPermissions) => {
        let user = this.$_cache.getUser();
        let op = teamPermissions[user.orgPartyId];
        if (!!op) {
            let orgDisc = op.find((t) => t.permissionTarget == MODULES.DISCUSSION);
            if (!!orgDisc) {
                this.orgPermissions[MODULES.DISCUSSION][MODULE_ACTIONS.ALL] = orgDisc.allow;
            }
            let orgCvrsht = op.find((t) => t.permissionTarget == MODULES.COVERSHEET);
            if (!!orgCvrsht) {
                this.orgPermissions[MODULES.COVERSHEET][MODULE_ACTIONS.ALL] = orgCvrsht.allow;
            }
            let orgLogo = op.find((t) => t.permissionTarget == MODULES.LOGO);
            if (!!orgLogo) {
                this.orgPermissions[MODULES.LOGO][MODULE_ACTIONS.SHOW] = orgLogo.allow;
            }
        }
    }

    resetPermissions = () => {
        this.orgPermissions = {};
        this.orgPermissions[MODULES.DISCUSSION] = {};
        this.orgPermissions[MODULES.COVERSHEET] = {};
        this.orgPermissions[MODULES.LOGO] = {};
        this.orgPermissions[MODULES.DISCUSSION][MODULE_ACTIONS.ALL] = MODULES_DEFAULT.DISCUSSION;
        this.orgPermissions[MODULES.COVERSHEET][MODULE_ACTIONS.ALL] = MODULES_DEFAULT.COVERSHEET;
        this.orgPermissions[MODULES.LOGO][MODULE_ACTIONS.SHOW] = MODULES_DEFAULT.LOGO;
    }

    fetchPermissions = (partyId) => {
        let tp = this.$_cache.getUserTeamPermissions();
        if (!tp || !tp[partyId]) {
            this.$_api.getUserPermissions().then((p) => {
                this.$_cache.setUserTeamPermissions(p);
            });
        }
    }

    isModuleAllowedForTeam = (subject: Subject, module): boolean => {
        let isAllowed = MODULES_DEFAULT[module];
        let op = this.$_cache.getUserTeamPermissions();
        let tp = !!op ? op[subject.teamPartyParentId] : null;
        if (!!tp) {
            let tmPerm = tp.find((t) => t.permissionTarget == module);
            !!tmPerm && (isAllowed = tmPerm.allow);
        }
        return isAllowed;
    }

    isDiscussionsAllowed = (subject?: Subject): boolean => {
        let isDiscAllowed = this.orgPermissions[MODULES.DISCUSSION][MODULE_ACTIONS.ALL];
        if (!subject) {
            subject = this.$_cache.getCurrentSubject();
        }
        if (!!isDiscAllowed && !!subject) {
            isDiscAllowed = this.isModuleAllowedForTeam(subject, MODULES.DISCUSSION);
        }
        return isDiscAllowed;
    }

    moduleDisabledAlert = ($event, module, subj?): void => {
        if (!!$event) {
            $event.preventDefault();
            $event.stopPropagation();
        }

        let toastrMsg;
        let teamPermissions = this.$_cache.getUserTeamPermissions();
        if (!subj) {
            subj = this.$_cache.getCurrentSubject();
        }

        if (!!teamPermissions) {
            let orgName = this.$_cache.get('userOrgName');
            let isDiscAllowed = this.orgPermissions[MODULES.DISCUSSION][MODULE_ACTIONS.ALL];
            if (!isDiscAllowed) {
                toastrMsg = Util.NO_MODULE_PERM_FOR_ORG.replace('$orgName', orgName).replace('$moduleName', module);
            } else {
                if (!!subj && !this.isModuleAllowedForTeam(subj, MODULES.DISCUSSION)) {
                    toastrMsg = Util.NO_MODULE_PERM.replace('$orgName', subj.teamOrgName).replace('$moduleName', module);
                } else {
                    toastrMsg = Util.NO_MODULE_PERM_FOR_ORG.replace('$orgName', orgName).replace('$moduleName', module);
                }
            }
        } else {
            let crntSub = subj;
            if (!crntSub) {
                var allSubs = angular.copy(this.$_cache.getSortedSubjects);
                if (allSubs.length == 1) {
                    crntSub = allSubs[0];
                }
            }
            if (!!crntSub) {
                let orgName = crntSub.teamOrgName;
                toastrMsg = Util.NO_MODULE_PERM.replace('$orgName', orgName).replace('$moduleName', module);
            }
        }
        toastr.success(toastrMsg);
    }
}

angular.module('eCareVault.common.services')
    .service('TeamPermissionService', TeamPermissionService);